// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/next.scss
// module id = 876
// module chunks = 142